import { generateHttpClient } from '@wisestamp/common';
import { accountSettingsUsersGatewayMethods } from './generated/proto/api';
import { BASE_ROUTE } from './consts';
/**
 * Auto generated client with all the API methods\
 * Pro tip: Don't forget to call the init method\
 * if any of the gateway methods requires auth^2 a IAuth
 * instance must be passed to the init method\
 * (Even if you are not using guarded methods)
 */
export const accountSettingsUsersGateway = generateHttpClient({
    baseRoute: BASE_ROUTE,
    methods: accountSettingsUsersGatewayMethods,
    sdkPackageName: '@msl/account-settings-users-gateway-sdk',
    requireAuth: true,
});
//# sourceMappingURL=api.js.map